import { useState } from "react";
import { Button } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import VampInfoDialog from "./VampInfoDialog";

// Trigger and dialog travel together so the tab bar can host the button without owning its state.
export default function VampInfoButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        size="small"
        startIcon={<HelpOutlineIcon />}
        onClick={() => setOpen(true)}
        sx={{
          flexShrink: 0,
          textTransform: "none",
          fontWeight: 600,
          color: "#465fff",
          "&:hover": { backgroundColor: "rgba(70, 95, 255, 0.06)" },
        }}
      >
        How VAMP rates work
      </Button>
      <VampInfoDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
